import PropTypes from "prop-types";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { sanitizeText } from "../../../utils/TextUtils";
import Loader from "../../../utils/Loader";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import { motion } from "framer-motion";
import {
  containerVariants,
  itemVariants,
  buttonAnimations,
  inputAnimations,
  headingVariants,
  sectionVariants,
  loadingButtonAnimations
} from "../../../utils/Animations";

const CourseAdd = ({ setIsAdd, getCoursesData }) => {
  const { rest_slug2 } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [courseData, setCourseData] = useState({
    name: "",
    // sequence: "",
  });

  const handleSave = async () => {
    setIsLoading(true);
    try {
      const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found in localStorage.");
        return;
      }
      const formData = new FormData();
      formData.append("name", courseData.name);
      // formData.append("sequence", courseData.sequence);
      const response = await axios.post(
        `${apiUrl}/api/v1/restaurant/${rest_slug2}/dish-courses`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      getCoursesData();
      toast.success(response?.data?.message || "Course added successfully!", {
        theme: "colored",
        autoClose: 1000,
      });
      setIsAdd(false);
      navigate(
        `/restaurantPanel/courseManagement/${localStorage.getItem("currentRestId") &&
        localStorage.getItem("currentRestId")}`
      );
    } catch (error) {
      const errors = error?.response?.data?.errors;
      if (errors) {
        for (const key in errors) {
          if (Array.isArray(errors[key])) {
            errors[key].forEach((message) => {
              toast.error(message, {
                theme: "colored",
                autoClose: 3000,
              });
            });
          }
        }
      } else {
        toast.error(error?.response?.data?.message, {
          theme: "colored",
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsAdd(false);
  };

  return (
    <motion.section
      initial={sectionVariants.initial}
      animate={sectionVariants.animate}
      transition={sectionVariants.transition}
      className="border-t border-[#D9D9D9] sm:mt-5 mt-0 pt-10"
    >
      <motion.h3
        initial={headingVariants.initial}
        animate={headingVariants.animate}
        transition={headingVariants.transition}
        className="text-2xl font-bold mb-2 poppins-medium"
      >
        Aggiungi Portata
      </motion.h3>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 border-[2px] border-[#8B24332B] md:p-10 p-4 lg:px-10 md:px-2 rounded-xl shadow-md font-sans"
      >
        <motion.div className="lg:flex justify-between gap-3" variants={containerVariants}>
          <motion.div
            className="flex md:flex-row flex-col w-full gap-6"
            variants={itemVariants}
          >
            <div className="flex flex-col md:w-[50%] w-full space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Nome
                <span className="text-red-500"> *</span>
              </label>
              <motion.input
                type="text"
                placeholder="Nome"
                className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                value={sanitizeText(courseData?.name)}
                onChange={(e) => setCourseData({ ...courseData, name: e.target.value })}
                {...inputAnimations}
              />
            </div>
            {/* <div className="flex flex-col md:w-[50%] w-full space-y-3">
              <label className="text-sm font-semibold poppins-medium text-[#404040]">
                Posizione
                <span className="text-red-500"> *</span>
              </label>
              <motion.input
                type="text"
                placeholder="Posizione"
                className="poppins-regular px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent border border-gray-300 focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                value={courseData?.sequence}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (/^\d{0,2}$/.test(inputValue)) {
                    if (inputValue === "0") {
                      return;
                    }
                    setCourseData({ ...courseData, sequence: inputValue });
                  }
                }}
                maxLength={2}
                {...inputAnimations}
              />
            </div> */}
          </motion.div>
        </motion.div>
        <motion.div
          className="flex sm:flex-row flex-col text-sm justify-start gap-4 mt-4"
          variants={itemVariants}
        >
          {isLoading ? (
            <motion.button
              disabled
              type="button"
              className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group"
              {...loadingButtonAnimations}
            >
              <Loader />
              Loading...
            </motion.button>
          ) : (
            <motion.button
              className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              onClick={handleSave}
              disabled={isLoading}
              {...buttonAnimations}
            >
              <TiTick size={"25px"} color="green" />
              <span className="poppins-regular">Salva</span>
            </motion.button>
          )}
          <motion.button
            className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={handleCancel}
            {...buttonAnimations}
          >
            <IoClose size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Annulla</span>
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.section>
  );
};

CourseAdd.propTypes = {
  setIsAdd: PropTypes.func.isRequired,
  getCoursesData: PropTypes.func.isRequired,
};

export default CourseAdd;